import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PaymentsPage } from '@/pages/payments';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { SKIP, TAKE } from '@/lib/constants/pagination';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import z from '@/lib/zod';
import { optionalSearchString } from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const paymentsSearchSchema = commonSearchSchema.extend({
  tab: z.string().nullish(),
  accountId: optionalSearchString(),
  paymentStatus: z.string().nullish(),
  subTab: z.string().nullish(),
  presentationDateFrom: optionalSearchString(),
  presentationDateTo: optionalSearchString(),
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  retryPaymentId: z.string().nullish(),
  sepa_payment: z.string().nullish(),
  /** Pannello Filtri: importo (valore assoluto) e stati delle distinte (CSV). */
  ...amountSearchParams,
  status: optionalSearchString(),
});

export const Route = createFileRoute('/protected/_layout/payments/_layout')({
  validateSearch: paymentsSearchSchema,
  loaderDeps: ({ search }) => ({
    skip: search.skip ?? SKIP,
    take: search.take ?? TAKE,
  }),
  component: PaymentsLayout,
});

function PaymentsLayout() {
  const { canAccessPayments, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessPayments} isLoading={isLoading}>
      <PaymentsPage />
      <Outlet />
    </RoleGuard>
  );
}
